import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function useSEO({ title, description }) {
  const { pathname } = useLocation();
  useEffect(() => {
    const base = "Ken's Gold";
    document.title = title ? `${title} | ${base}` : `${base} | Premium Wellness Shots — 100% Raw & Organic`;

    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc && description) {
      metaDesc.setAttribute("content", description);
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      const url = new URL(pathname, canonical.href).href;
      canonical.href = url;
      document.querySelector('meta[property="og:url"]')?.setAttribute("content", url);
    }
    for (const selector of ['meta[property="og:title"]', 'meta[name="twitter:title"]']) {
      document.querySelector(selector)?.setAttribute("content", document.title);
    }
    if (description) {
      for (const selector of ['meta[property="og:description"]', 'meta[name="twitter:description"]']) {
        document.querySelector(selector)?.setAttribute("content", description);
      }
    }
    document.querySelector('meta[name="robots"]')?.setAttribute("content", pathname.startsWith("/admin") || pathname.startsWith("/payment") ? "noindex, nofollow" : "index, follow");
  }, [title, description, pathname]);
}
